module.exports = __webpack_public_path__ + "static/img/说明1.fafac54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mengceng/说明1.png
// module id = V6EG
// module chunks = 1